import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@app/services/toast.service';
import { EncryptionService } from '../../services/encryption.service';
import { DealerService } from '../../services/dealer.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-payment-transaction-status',
    templateUrl: './payment-transaction-status.component.html',
    styleUrl: './payment-transaction-status.component.scss',})

export class PaymentTransactionStatusComponent {
  gateway_name: string = '';
  ref_num: string = '';
  orderStatus: string = ''
  orderNumbers: string[] = [];
  status_code: any;
  userType: string | null = '';
  payment_id: string = '';

  constructor(private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastService,
    private encryptionService: EncryptionService,
    private dealerService: DealerService) {

  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.gateway_name = params['gateway'] || '';
      this.ref_num = params['txn_id'];
      if (params['transaction_msg']) {
        this.orderStatus = params['transaction_msg'].toLowerCase() || '';
      }
      if (params['status_code']) {
        this.status_code = params['status_code'].toLowerCase() || '';
      }
      if(params['payment_id']){
        this.payment_id = params['payment_id'].toLowerCase() || '';
      }
      const orderNumbersParam = params['o_n'] || '';
      if (orderNumbersParam) {
        this.orderNumbers = orderNumbersParam.split(',').map((o: any) => o.trim());
      }
    });
    // this.dealerService.setOrder(this.orderNumbers[0]);

    this.userType = this.encryptionService.getFromLocalStorage('user_type');
    if (this.userType === 'dealer' && this.orderNumbers[0]) {
      setTimeout(() => {
        this.router.navigate([`/dealer/order/payment-details/${this.orderNumbers[0]}`]);
      }, 5000); // 10 seconds delay
    }

  }
  copyReferenceNo(refer: string): void {
    navigator.clipboard.writeText(refer).then(() => {
      this.toastr.success(`Reference number ${refer} copied to clipboard!`);
    }).catch(err => {
      console.error('Failed to copy Reference number:', err);
    });
  }
}